import React from 'react';
import { TextBold } from './AddUserComponents';
import SearchArea from './SearchArea';
import UserList from './UserList';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';

class UserView extends React.Component {
  render() {
    const { hasMoreItems, users, selectedUsers, showSearchArea, resetPageNumber } = this.props;
    const { onSearchChange, onLoadMoreItems, onUserClick } = this.props.events;
    const { root, searchArea, title, userList } = this.props.className;

    return (
      <div className={root}>
        <TextBold className={title}>{this.props.title}</TextBold>
        {showSearchArea && (
          <SearchArea
            id="search-participant"
            className={searchArea}
            onSubmit={onSearchChange}
            placeholderText={I18n.t('tasks.users.searchPlaceholder')}
          />
        )}
        <UserList
          users={users}
          hasMoreItems={hasMoreItems}
          selectedUsers={selectedUsers}
          remountComponent={resetPageNumber}
          className={userList}
          events={{
            onUserClick: onUserClick,
            onLoadMoreItems: onLoadMoreItems
          }}
        />
      </div>
    );
  }
}

UserView.propTypes = {
  title: PropTypes.string,
  users: PropTypes.array,
  selectedUsers: PropTypes.array,
  hasMoreItems: PropTypes.bool,
  showSearchArea: PropTypes.bool,
  events: PropTypes.shape({
    onSearchChange: PropTypes.func,
    onLoadMoreItems: PropTypes.func,
    onUserClick: PropTypes.func
  }),
  className: PropTypes.shape({
    root: PropTypes.string,
    title: PropTypes.string,
    searchArea: PropTypes.string,
    userList: PropTypes.string
  })
};

UserView.defaultProps = {
  title: '',
  users: [],
  selectedUsers: [],
  hasMoreItems: true,
  showSearchArea: true,
  events: {
    onSearchChange: e => console.log('Event onSearchChange', e),
    onLoadMoreItems: e => console.log('Event onLoadMoreItems', e),
    onUserClick: e => console.log('Event onUserClick', e)
  },
  className: PropTypes.shape({
    root: '',
    title: '',
    searchArea: '',
    userList: ''
  })
};

export default UserView;
